/** Whether a student row is linked to a guardian or self-student platform user. */
export function studentHasLinkedGuardian(student: { parentId?: string | null }): boolean {
  const parentId = student.parentId?.trim();
  return !!parentId && !parentId.startsWith('pending_');
}

/**
 * Academy staff may hard-delete only manual students with no linked account
 * (roster-only or awaiting signup).
 */
export function isStudentDeletableByAcademy(student: {
  isManual?: boolean;
  parentId?: string | null;
}): boolean {
  return student.isManual === true && !studentHasLinkedGuardian(student);
}

/** Booking or payment rows that indicate money was collected (including refunds). */
export function bookingHasCompletedPayment(
  booking: { paymentStatus?: string },
  payments: ReadonlyArray<{ status?: string }>
): boolean {
  if (booking.paymentStatus === 'paid' || booking.paymentStatus === 'refunded') {
    return true;
  }
  return payments.some((p) => p.status === 'succeeded' || p.status === 'refunded');
}

export const STUDENT_DELETE_PAYMENT_BLOCKED_MESSAGE =
  'Cannot delete student with completed payments. Contact support if you need help.';

export const STUDENT_DELETE_BLOCKED_TOOLTIP =
  'Only manual roster students without a linked account can be deleted. Students with a guardian or self-student account cannot be removed this way.';
